import React, {Component} from 'react';
import LoadingSpinner from "../Utils/LoadingSpinner";
import { Formik, Form, Field } from 'formik';

const Agreement = (props) => {
    const mfg = props.partners.find( (partner) => partner.id === props.mfg_id );
    const svc = props.partners.find( (partner) => partner.id === props.svc_id );
    const sales = props.partners.find( (partner) => partner.id === props.sales_id );

    console.log("Agreement", props);

    return (
        <div>
            {props.name} <button onClick={props.editAgreemet}> Modify agreement</button>
            <button onClick={props.deleteAgreement}>Delete agreement</button>
            <br/>
            Manufacturer: {mfg.name} ( {mfg.email} ) Percentage: {props.mfg_perc}<br/>
            Service Provider: {svc.name} ( {svc.email} ) Percentage: {props.svc_perc}<br/>
            Sales: {sales.name} ( {sales.email} ) Percentage: {props.sales_perc}<br/>
            <hr/>
        </div>
    );
};

const AgreementForm = (props) => {

    let agreement_values;
    if ( props.newItem) {
        agreement_values = {
            id: 0,
            name: 'New Agreement',
            mfg_id: props.partners[0].id,
            mfg_perc: 1,
            svc_id: props.partners[0].id,
            svc_perc: 1,
            sales_id: props.partners[0].id,
            sales_perc: 1,
        };

    }
    else {
        const mfg = props.partners.find((partner) => partner.id === props.mfg_id);
        const svc = props.partners.find((partner) => partner.id === props.svc_id);
        const sales = props.partners.find((partner) => partner.id === props.sales_id);

        agreement_values = {
            id: props.id,
            name: props.name,
            mfg_id: mfg.id,
            mfg_perc: props.mfg_perc,
            svc_id: svc.id,
            svc_perc: props.svc_perc,
            sales_id: sales.id,
            sales_perc: props.sales_perc,
        };

    }


    return(
        <div>
            <h1>{props.name} </h1>
            <Formik
                initialValues={agreement_values}

                onSubmit={ (values) => {
                    props.onFormSubmission(values);
                }}
            >
                {({
                      values,
                      handleChange,
                      handleBlur,
                      isSubmitting,
                  }) => (
                    <Form>
                        Agreement <Field name="name" /><br/>

                        Manufacturer
                        <select name="mfg_id" value={values.mfg_id} onChange={handleChange}
                                             onBlur={handleBlur} >
                            { props.partners.map( partner => ( <option value={partner.id} key={partner.id}
                                                                       label={partner.email} />  ) ) }
                        </select>
                        <Field name="mfg_perc" /><br/>

                        Service Provider
                        <select name="svc_id" value={values.svc_id} onChange={handleChange}
                                             onBlur={handleBlur} >
                            { props.partners.map( partner => ( <option value={partner.id} key={partner.id}
                                                                       label={partner.email} />  ) ) }
                        </select>
                        <Field name="svc_perc" /><br/>

                        Sales
                        <select name="sales_id" value={values.sales_id} onChange={handleChange}
                                             onBlur={handleBlur} >
                            { props.partners.map( partner => ( <option value={partner.id} key={partner.id}
                                                                       label={partner.email} />  ) ) }
                        </select>
                        <Field name="sales_perc" /><br/>


                        <button type="submit" disabled={isSubmitting}>
                            Submit
                        </button>
                    </Form>
                )}

            </Formik>
        </div>
    )
};


class EditableAgreement extends Component {
    state = {
        open: false,
        loading: false,
    };

    onFormSubmission = (agreement) => {
        console.log('Values:', agreement);
        this.setState({loading:true}, () => {

            if ( this.props.newItem ){
                this.props.simGps.createAgreement( agreement, () => {
                    this.setState({open:false, loading: false});
                    this.props.onUpdate();
                } );

            }
            else {
                this.props.simGps.modifyAgreement( agreement, () => {
                    this.setState({open:false, loading: false});
                    this.props.onUpdate();
                } );
            }
        });

    };

    deleteAgreement = () => {
        console.log('Deleting :', this.props.id);
        this.setState({loading:true}, () => {
                this.props.simGps.deleteAgreement( this.props.id, () => {
                    this.setState({open:false, loading: false});
                    this.props.onUpdate();
                } );
        });
    };


    editAgreemet = () => {
      this.setState({open:true})
    };

    createAgreement = () => {
        this.setState({open:true})
    };

    render() {
        if (this.state.loading) {
            return (<LoadingSpinner text="Updating agreement ..."/>);
        }else{
            if ( this.state.open )
                return ( <AgreementForm {...this.props} onFormSubmission={this.onFormSubmission} /> );
            else if ( this.props.newItem )
                return ( <button  onClick={this.createAgreement}> Create new agreement </button> );
            else
                return ( <Agreement {...this.props} editAgreemet={this.editAgreemet}
                                    deleteAgreement={this.deleteAgreement}
                /> );
        }
    }
}


class AgreementsList extends Component {
    state = {
        loading: true,
        got_partners: false,
        got_agreements: false,
    };

    componentDidMount() {

        this.props.simGps.getPartnersList(
            (success, result) => {
                if (success) {
                    this.setState({partners: result, got_partners: true})
                } else {
                    this.setState({loading: false})
                }
            }
        );

        this.getAgreements();
    }


    getAgreements = () =>  {
        this.props.simGps.getAgreementsList(
            (success, result) => {
                if (success) {
                    console.log("Aggr", result);
                    this.setState({agreements: result, got_agreements: true})
                } else {
                    this.setState({loading: false})
                }
            }
        );
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ( this.state.loading ) {
            if (this.state.got_partners && this.state.got_agreements) {
                this.setState({loading: false})
            }
        }
    }

    render() {
        if (this.state.loading) {
            return (<LoadingSpinner text="Retrieving agreements ..."/>);
        } else {
            return (
                <div>
                    {this.state.agreements.map( agreement => (
                        <EditableAgreement {...this.props} key={agreement.id} {...agreement}
                                           partners={this.state.partners}
                                           onUpdate={this.getAgreements}
                        />
                    ))}
                    <EditableAgreement {...this.props}  newItem
                                       partners={this.state.partners}
                                       onUpdate={this.getAgreements}/>
                </div>

            );
        }
    }
}

export default AgreementsList;
